import React from 'react';
import { Input, InputNumber, Space } from 'antd';
import styles from '../../../event-timeline.module.css';

interface CounterReachedParamsProps {
  params: any;
  setParams: (params: any) => void;
}

const CounterReachedParams: React.FC<CounterReachedParamsProps> = ({
  params,
  setParams,
}) => {
  return (
    <div className={styles.parameterContainer}>
      <Space direction='vertical' style={{ width: '100%' }}>
        <span className={styles.label}>Counter ID:</span>
        <Input
          value={params.counterId}
          onChange={(e) => setParams({ ...params, counterId: e.target.value })}
          placeholder='Enter counter ID'
        />
        <span className={styles.label}>Value:</span>
        <InputNumber
          value={params.value}
          onChange={(value) => setParams({ ...params, value })}
          min={0}
          style={{ width: '100%' }}
        />
      </Space>
    </div>
  );
};

export default CounterReachedParams;
